export default __webpack_public_path__ + "static/media/KIRO.2ca40e83.png";